const apiBaseUrlExchangeRate = process.env.REACT_APP_EXCHANGE_RATE_BASE_URL;
const config = {
  apiUrl: {
    exchangeRate: `${apiBaseUrlExchangeRate}/bank/remittance/exchange-rate`,
    compareRate: `${apiBaseUrlExchangeRate}/bank/remittance/providers/fx-rate`,
  },
};

export default config;
